<template>
  <div class="service-node-container">
    <star-condition-layout
      class="search"
      :onSearch="handleSearch"
      :onReset="handleReset"
      :loading="loading"
    >
      <star-condition-cell label="执行状态">
        <a-select v-model="selectServerStatus" style="width: 100%">
          <a-select-option :value="99">全部</a-select-option>
          <a-select-option :value="0">正常</a-select-option>
          <a-select-option :value="-1">异常</a-select-option>
        </a-select>
      </star-condition-cell>
    </star-condition-layout>

    <div class="service-node-inner">
      <TableHeadIcons :onRefresh="handleSearch" :size.sync="tableDensity" :columns="columns" />
      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="serverIp"
        :columns="showColumns"
        :data-source="tableData"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="serverMemoryTotal" slot-scope="text, record"
          >{{ record.serverMemoryTotal | toGB }} GB</span
        >
        <span slot="serverMemoryUsed" slot-scope="text, record">
          <div class="used-container">
            <div
              :class="[record.isMemoryError ? 'error-fill' : 'fill']"
              :style="{ width: `${(100 * record.serverMemoryUsed) / record.serverMemoryTotal}%` }"
            ></div>
            <div class="text">{{ record.serverMemoryUsed | toGB }} GB</div>
          </div>
        </span>

               <span slot="serverStatus" slot-scope="task, record">
          <a-tag color="green" v-if="record.serverStatus != -1" > 正常 </a-tag>

          <a-tag color="red" v-if="record.serverStatus == -1"> 异常 </a-tag>
        </span>


        <span slot="serverTask" slot-scope="task, record">
          <router-link
            :to="{ name: 'dispatch_task_manage', query: { serverIp: record.serverIp } }"
            >{{ task }}</router-link
          >
        </span>
        <span slot="serverCpu" slot-scope="text, record" :class="[record.isCpuError ? 'error-cpu-text':'']" >{{ record.serverCpu.toFixed(2) }} %</span>
      </a-table>
    </div>
  </div>
</template>

<script>
import TableHeadIcons from '@/components/TableHeadIcons'
import { onHttpResponseSilent } from '@/utils/request'
import { getServiceNodeListApi } from '@/api/System/ServiceNode'
export default {
  components: { TableHeadIcons },
  data() {
    return {
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 20,
        showTotal: (total) => `共 ${total} 条`,
        total: 0,
        size: 'default'
      },
      loading: false,
      tableDensity: 'middle',
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'center',
          show: true,
          slots: { title: 'indexTitle' },
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '节点名称',
          align: 'center',
          dataIndex: 'serverHostName',
          show: true
        },
        {
          title: '节点ip',
          dataIndex: 'serverIp',
          align: 'center',
          show: true
        },
        {
          title: '内存大小',
          dataIndex: 'serverMemoryTotal',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'serverMemoryTotal' }
        },
        {
          title: '内存已用大小',
          dataIndex: 'serverMemoryUsed',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'serverMemoryUsed' }
        },
        {
          title: 'CPU使用率',
          dataIndex: 'serverCpu',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'serverCpu' }
        },
        {
          title: '节点状态',
          dataIndex: 'serverStatus',
          align: 'center',
          show: true,
          scopedSlots: { customRender: 'serverStatus' }
        },
        {
          title: '正在运行任务数',
          dataIndex: 'serverTask',
          show: true,
          align: 'center',
          scopedSlots: { customRender: 'serverTask' }
        },

        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updateTime',
          show: true
        }
      ],
      selectServerStatus: 99
    }
  },
  filters: {
    toGB(num) {
      return (num / 1024 / 1024 / 1024).toFixed(2)
    }
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  mounted() {
    this.handleSearch()
  },
  methods: {
    handleReset() {
      this.selectServerStatus = 99
      this.handleSearch()
    },
    handleSearch() {
      var serverStatus = null
      if (this.selectServerStatus != 99) {
        serverStatus = this.selectServerStatus
      } else {
        serverStatus = null
      }
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        serverStatus: serverStatus
      }
      this.loading = true
      getServiceNodeListApi(query)
        .then(onHttpResponseSilent)
        .then((res) => {
          let { data, extra } = res
          this.tableData = data || []
          this.tableData.forEach((data) => {
            data['serverMemoryUsed'] = data['serverMemoryUsed'] || 0
            data['serverMemoryTotal'] = data['serverMemoryTotal'] || 1
            if (data['serverMemoryUsed'] / data['serverMemoryTotal'] >= 0.8) {
              data['isMemoryError'] = true
            } else {
              data['isMemoryError'] = false
            }

            if (data['serverCpu'] >= 80) {
              data['isCpuError'] = true
            } else {
              data['isCpuError'] = false
            }
          })
          this.pagination.total = extra.page.pageCount || 0
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.handleSearch()
    }
  }
}
</script>

<style lang="less" scoped>
.service-node-container {
  padding: 20px;

      .error-cpu-text {
        color: #fc8989;
      }

  .search {
    margin-bottom: 20px;
  }
  .service-node-inner {
    background: white;
    padding: 0 16px;

    .used-container {
      position: relative;
      border: 1px solid #bae7ff;

      .fill {
        background: #bae7ff;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
      }

      .error-fill {
        background: #fc8989;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
      }



      .text {
        position: relative;
        z-index: 2;
        padding-left: 5px;
      }
    }
  }
}
</style>
